export default "__VITE_ASSET__DyY90MS9__"